import { defineMessages } from "react-intl";

export default defineMessages({
  genericDecline: {
    id: "creditCardError.genericDecline",
    defaultMessage: "Your card has been rejected",
  },
  insufficientFunds: {
    id: "creditCardError.insufficientFunds",
    defaultMessage: "Your card does not have sufficient funds",
  },
  lostCard: {
    id: "creditCardError.lostCard",
    defaultMessage: "Your card has been denied",
  },
  stolenCard: {
    id: "creditCardError.stolenCard",
    defaultMessage: "Your card has been denied",
  },
  expiredCard: {
    id: "creditCardError.expiredCard",
    defaultMessage: "Your card has expired",
  },
  CVC: {
    id: "creditCardError.CVC",
    defaultMessage: "Your card security code is incorrect",
  },
  processingError: {
    id: "creditCardError.processingError",
    defaultMessage:
      "An error occurred while processing your card. Please try again later",
  },
  incorrectNumber: {
    id: "creditCardError.incorrectNumber",
    defaultMessage: "Your card number is invalid",
  },
  incompleteNumber: {
    id: "creditCardError.incompleteNumber",
    defaultMessage: "The card number is incomplete",
  },
  incompleteCVC: {
    id: "creditCardError.incompleteCVC",
    defaultMessage: "The cvc is incomplete",
  },
  incompleteExpiry: {
    id: "creditCardError.incompleteExpiry",
    defaultMessage: "The expiration date is incomplete",
  },
});
